import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";

/**
 * Page shown to users whose accounts are not yet activated
 * Redirects active users back to home
 */
export default function RequireActive() {
  const { user } = useAuth();

  // If user is active, redirect to home
  if (user?.isActive) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
        <h1 className="mb-4 text-center text-2xl font-bold text-gray-900">
          Account Not Active
        </h1>
        <p className="text-center text-gray-600">
          Your account is currently inactive. Please contact an administrator to
          activate your account.
        </p>
      </div>
    </div>
  );
}
